import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";

import blueArrowRightImage from "assets/images/pure-tone-audiogram-v2/blueArrowRightImage.svg";
import blueBracketImage from "assets/images/pure-tone-audiogram-v2/blueBracketImage.svg";
import blueSquareImage from "assets/images/pure-tone-audiogram-v2/blueSquareImage.svg";
import blueXImage from "assets/images/pure-tone-audiogram-v2/blueXImage.svg";
import redArrowLeftImage from "assets/images/pure-tone-audiogram-v2/redArrowLeftImage.svg";
import redBracketImage from "assets/images/pure-tone-audiogram-v2/redBracketImage.svg";
import redCircleImage from "assets/images/pure-tone-audiogram-v2/redCircleImage.svg";
import redTriangleImage from "assets/images/pure-tone-audiogram-v2/redTriangleImage.svg";
import mclImage from "assets/images/pure-tone-audiogram-v2/mclImage.svg";
import uclImage from "assets/images/pure-tone-audiogram-v2/uclImage.svg";
import mclLeftImage from "assets/images/pure-tone-audiogram-v2/mclLeftImage.svg";
import mclRightImage from "assets/images/pure-tone-audiogram-v2/mclRightImage.svg";
import uclLeftImage from "assets/images/pure-tone-audiogram-v2/uclLeftImage.svg";
import uclRightImage from "assets/images/pure-tone-audiogram-v2/uclRightImage.svg";

import aidedImage from "assets/images/pure-tone-audiogram-v2/aidedImage.svg";
import unaidedImage from "assets/images/pure-tone-audiogram-v2/unaidedImage.svg";

export const LEGEND_IMAGE: { [key: string]: string } = {
  ACUL: blueXImage,
  BCUL: blueArrowRightImage,
  ACML: blueSquareImage,
  BCML: blueBracketImage,
  ACUR: redCircleImage,
  BCUR: redArrowLeftImage,
  ACMR: redTriangleImage,
  BCMR: redBracketImage,
  MCL: mclImage,
  MCLL: mclLeftImage,
  MCLR: mclRightImage,
  UCL: uclImage,
  UCLL: uclLeftImage,
  UCLR: uclRightImage,
  A: aidedImage,
  AL: aidedImage,
  AR: aidedImage,
  S: unaidedImage,
  SL: unaidedImage,
  SR: unaidedImage,
};

type PureToneAudiogramLegendItemProps = {
  label: string;
  value: string;
};

export default function PureToneAudiogramLegendItem({
  label,
  value,
}: PureToneAudiogramLegendItemProps) {
  const isLargeScreen = useMediaQuery("(min-width:1700px)");
  return (
    <Stack direction="column" justifyContent="flex-end" alignItems="center">
      <Typography
        sx={{
          textAlign: "center",
          mb: 1,
          fontSize: isLargeScreen ? "14px" : "12px",
        }}
      >
        {label}
      </Typography>
      <Box
        component="img"
        src={LEGEND_IMAGE[value]}
        sx={{ width: 32, mb: 1 }}
      />
    </Stack>
  );
}
